import {
  FETCH_SUPPORT_BADGE,
  FETCH_SUPPORT_BADGE_SUCCESS,
  FETCH_MY_SUPPORT_BADGE,
  FETCH_MY_SUPPORT_BADGE_SUCCESS,
  CLEAR_SUPPORT_BADGE,
} from "./actionTypes"

/** Rozet sayaçlarını sunucudan tazeler (yanıt gönderildiğinde, sayfa değiştiğinde). */
export const fetchSupportBadge = () => ({
  type: FETCH_SUPPORT_BADGE,
})

export const fetchSupportBadgeSuccess = (data) => ({
  type: FETCH_SUPPORT_BADGE_SUCCESS,
  payload: data,
})

/** Kullanıcının kendi taleplerine gelen yanıt sayısını tazeler. */
export const fetchMySupportBadge = () => ({
  type: FETCH_MY_SUPPORT_BADGE,
})

export const fetchMySupportBadgeSuccess = (data) => ({
  type: FETCH_MY_SUPPORT_BADGE_SUCCESS,
  payload: data,
})

/** Yetkisi olmayan kullanıcıda rozet sayaçlarını sıfırlar. */
export const clearSupportBadge = () => ({
  type: CLEAR_SUPPORT_BADGE,
})
